<template>
  <div>
    <HeadersDetalhesResumo
      :apelido="imovel.apelido"
      :proprietario="imovel.proprietario"
      :tipo="imovel.tipo"
      :savoynet="imovel.savoynet"
    >
    </HeadersDetalhesResumo>
    <v-layout row wrap align-center class="secondary white--text detalhes-header">
      <v-flex xs2>
        <v-container fluid class="py-2">      
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-left">
              <v-btn icon :to="({ name: 'ImoveisDetalhesResumo', params: { id: $route.params.id } })" class="ma-0 white--text">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs8>
        <v-container fluid class="py-2">      
          <v-layout row wrap>
            <v-flex xs12>
              <span class="subtitulo">Valor</span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs2>
        <v-container fluid class="py-2">
          <v-layout row wrap>
            <v-flex xs12 v-if="canEditValor">
              <v-btn flat @click.stop="onSubmit" :disabled="isFormInvalid">
                <span class="subtitulo">Salvar</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <form v-on:submit.prevent="onSubmit">
      <v-layout row wrap class="pt-5 readonly-form" :class="{ 'readonly-form--blocked': !canEditValor }">
        <v-flex xs12 sm10 offset-sm1 md8 offset-md2>
          <v-container fluid>
            <v-layout row wrap class="mt-3">
              <v-flex xs12>
                <v-text-field
                  v-model="form.fields.estimativa_valor"
                  label="Estimativa do valor do imóvel"
                  v-validate="'required'"
                  name="estimativa_valor"
                  data-vv-as="estimativa do valor do imóvel"
                  :error-messages="errors.has('estimativa_valor') ? errors.first('estimativa_valor') : []"
                  v-money="'money'"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-menu
                  lazy
                  v-model="dataMenu"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-left="40"
                  max-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    prepend-icon="today"
                    v-model="form.fields.estimativa_data_formatada"
                    label="Data da estimativa"
                    readonly
                  >
                  </v-text-field>
                  <v-date-picker
                    v-model="form.fields.estimativa_data"
                    locale="pt-br"
                    autosave
                    :date-format="date => new Date(date).toLocaleDateString()"
                    :formatted-value.sync="form.fields.estimativa_data_formatada"
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12>              
                <v-text-field
                  v-model="form.fields.regiao_valor"
                  label="Valor do m² da região"
                  name="regiao_valor"
                  v-money="'money'"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </form>
    <ButtonsObservacoesAnexos></ButtonsObservacoesAnexos>
  </div>
</template>

<script>
  import _ from 'lodash'
  import axios from 'axios'
  import { apiURL } from '@/config'
  import HeadersDetalhesResumo from '../Headers/HeadersDetalhesResumo'
  import ButtonsObservacoesAnexos from './ButtonsObservacoesAnexos'
  import moment from 'moment'
  import AwesomeMask from 'awesome-mask'
  import currencyFormatter from 'currency-formatter'
  import moneyOptions from '@/moneyOptions'
  
  export default {
    components: {
      HeadersDetalhesResumo,
      ButtonsObservacoesAnexos
    },
    directives: {
      'money': AwesomeMask
    },
    data () {
      return {
        dataMenu: false,
        form: {
          fields: {
            estimativa_valor: null,
            estimativa_data: moment().format('YYYY-MM-DD'),
            estimativa_data_formatada: moment().format('DD/MM/YYYY'),
            regiao_valor: null
          }
        }
      }
    },
    computed: {
      imovel () {
        return this.$store.getters['imoveis/detalhes']
      },
      canViewValor () {
        return this.$hasGranularPermission('valor', 'view')
      },
      canEditValor () {
        return this.$hasGranularPermission('valor', 'edit')
      },
      isFormInvalid () {
        return Object.keys(this.fields).some(key => this.fields[key].invalid) || _.isEmpty(_.omitBy(this.form.fields, _.isEmpty))
      }
    },
    watch: {
      imovel () {
        if (this.imovel.hasOwnProperty('valor')) {
          this.form.fields.estimativa_valor = currencyFormatter.format(this.imovel.valor.data.estimativa_valor, moneyOptions)
          this.form.fields.estimativa_data = moment(this.imovel.valor.data.estimativa_data).format('YYYY-MM-DD')
          this.form.fields.estimativa_data_formatada = moment(this.imovel.valor.data.estimativa_data).format('DD/MM/YYYY')
          this.form.fields.regiao_valor = currencyFormatter.format(this.imovel.valor.data.regiao_valor, moneyOptions)
        }
      }
    },
    methods: {
      onSubmit () {
        if (!this.canEditValor) return
        this.$store.dispatch('utils/showLoading')

        this.$validator.validateAll().then((result) => {
          if (result) {
            const formattedFields = Object.assign({}, this.form.fields)
            formattedFields.estimativa_valor = currencyFormatter.unformat(formattedFields.estimativa_valor, moneyOptions)
            formattedFields.regiao_valor = currencyFormatter.unformat(formattedFields.regiao_valor, moneyOptions)

            axios.patch(`${apiURL}/imoveis/${this.$route.params.id}`, { valor: formattedFields }).then((response) => {
              this.$router.push({ name: 'ImoveisDetalhesResumo', params: { id: response.data.data.id } })
              this.$store.dispatch('utils/hideLoading')
            }, () => {
              this.$store.dispatch('utils/showSnackbar', {
                text: 'Servidor indisponível. Tente novamente mais tarde.'
              })
              this.$store.dispatch('utils/hideLoading')
            })
          } else {
            this.$store.dispatch('utils/showSnackbar', {
              type: 'error',
              text: 'Preencha os campos corretamente'
            })
            this.$store.dispatch('utils/hideLoading')
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// DetalhesValor.vue?2c32d9e8